
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Container, Card, Box, Typography, TextField, Snackbar, Alert } from "@mui/material";
// import { LoadingButton } from "@mui/lab";
// import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";
// import { resendOtp } from "../actions/authActions";
// const Verification = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const [otp, setOtp] = useState(["", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);
//   const [timer, setTimer] = useState(120);
//   const [isTimerActive, setIsTimerActive] = useState(true);
//   const [isBlocked, setIsBlocked] = useState(false); 
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" }); 
//   const [resendLoading, setResendLoading] = useState(false);
//   const [sentOtp, setSentOtp] = useState(location.state?.sentOtp || "");
//   const inputRefs = useRef([]);
//   const { phoneNumber, userData } = location.state || {};
//   const [showResendTimer, setShowResendTimer] = useState(true); 
// const [resendTimer, setResendTimer] = useState(30);
//   useEffect(() => {
//     if (!phoneNumber || !sentOtp) {
//       toast.error("Invalid access. Redirecting to login.");
//       navigate("/login", { replace: true });
//     }
//   }, [phoneNumber, sentOtp, navigate]);
//   useEffect(() => {
//     if (isTimerActive && timer > 0) {
//       const countdown = setInterval(() => {
//         setTimer((prevTimer) => {
//           if (prevTimer <= 1) {
//             clearInterval(countdown);
//             setIsBlocked(true);
//             setSnackbar({
//               open: true,
//               message: "OTP time expired. Please request a new OTP.",
//               severity: "error",
//             });
//             return 0;
//           }
//           return prevTimer - 1;
//         });
//       }, 1000);
//       return () => clearInterval(countdown);
//     }
//   }, [timer, isTimerActive]);
//   const handleOtpChange = (e, index) => {
//     const value = e.target.value;
//     if (/[^0-9]/.test(value)) return;
//     const updatedOtp = [...otp];
//     updatedOtp[index] = value;
//     setOtp(updatedOtp);
//     if (value && index < otp.length - 1) {
//       inputRefs.current[index + 1]?.focus();
//     }
//   };
//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index]) {

//       if (index > 0) {
//         inputRefs.current[index - 1]?.focus();
//       }
//     }
//   };
//   const handleOtpSubmit = () => {
//     const enteredOtp = otp.join("");
//     if (!enteredOtp || enteredOtp !== sentOtp) { 
//       setSnackbar({
//         open: true,
//         message: "Invalid OTP. Please try again.",
//         severity: "error",
//       });
//       return;
//     }
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//       setSnackbar({
//         open: true,
//         message: "OTP Verified Successfully!",
//         severity: "success",
//       });
//       localStorage.setItem("phoneNumber", phoneNumber);
//       localStorage.setItem("sentOtp", sentOtp);   
//       localStorage.setItem("userData", JSON.stringify(userData));
//       navigate("/home", { state: { phoneNumber, userData: userData?.ResultSet || null } });
//     }, 2000);
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     setShowResendTimer(false);  
//     setResendTimer(30); 
//     try {
//       const response = await dispatch(resendOtp(phoneNumber));
//       if (response.success) {
//         setTimer(90);
//         setIsBlocked(false);
//         setSnackbar({
//           open: true,
//           message: "OTP has been resent successfully.",
//           severity: "success",
//         });
//         setSentOtp(response.data);
//       } else {
//         setSnackbar({
//           open: true,
//           message: response.error.message || "Failed to resend OTP.",
//           severity: "error",
//         });
//       }
//     } catch (err) {
//       console.error("Error during resend OTP:", err);
//       setSnackbar({
//         open: true,
//         message: "Unexpected error. Please try again.",
//         severity: "error",
//       });
//     } finally {
//       setResendLoading(false);
//       const resendCountdown = setInterval(() => {
//         setResendTimer((prev) => {
//           if (prev <= 1) {
//             clearInterval(resendCountdown);
//             setShowResendTimer(true);  
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }
//   };
//   const handleCloseSnackbar = () => {
//     setSnackbar((prevState) => ({ ...prevState, open: false }));
//   };
//   return (
//     <Container
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         backgroundColor: "#F8F9FA",
//         padding: 2,
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//       }}
//     >
//       <Card sx={{ borderRadius: 5, boxShadow: 8, padding: 4, maxWidth: 400 }}>
//         <Box textAlign="center" mb={2}>
//           <Typography variant="h4" fontWeight={600}>
//             Verify OTP
//           </Typography>
//           <Typography variant="subtitle1" color="textSecondary" mt={1}>
//             Enter the OTP sent to {phoneNumber}
//           </Typography>
//         </Box>
//         <Box display="flex" justifyContent="space-between" mb={3}>
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e, index)}
//               onKeyDown={(e) => handleKeyDown(e, index)}
//               inputProps={{
//                 maxLength: 1,
//                 disabled: isBlocked,
//               }}
//               sx={{
//                 width: "50px",
//                 textAlign: "center",
//                 '& input': { textAlign: 'center' },
//               }}
//               inputRef={(el) => (inputRefs.current[index] = el)}
//             />
//           ))}
//         </Box>
//         <Box textAlign="center" mb={2}>
//           {isTimerActive ? (
//             <Typography variant="body2" color="textSecondary">
//             Time left: {Math.floor(timer / 60)}:
//             {timer % 60 < 10 ? "0" + (timer % 60) : timer % 60}
//           </Typography>
//           ) : (
//             <Typography variant="body2" color="error">
//               OTP expired. Please request a new one.
//             </Typography>
//           )}
//         </Box>
//         <Box>
//   <LoadingButton
//     onClick={handleOtpSubmit}
//     loading={loading}
//     variant="contained"
//     sx={{
//       width: "100%",
//       backgroundColor: "#0049AF",
//       textTransform: "capitalize",
//       borderRadius: 3,
//       mb: 2,
//     }}
//     disabled={isBlocked}
//   >
//     <span style={{ color: "#fff", fontSize: 16, fontWeight: 400 }}>
//       Verify OTP
//     </span>
//   </LoadingButton>

//     {isBlocked && showResendTimer && (
//       <LoadingButton
//         onClick={handleResendOtp}
//         loading={resendLoading}
//         variant="outlined"
//         sx={{
//           width: "100%",
//           textTransform: "capitalize",
//           borderRadius: 3,
//         }}
//       >
//         <span style={{ fontSize: 16, fontWeight: 400 }}>Resend OTP</span>
//       </LoadingButton>
//     )}
//  {!showResendTimer && (
//     <Typography variant="body2" color="textSecondary" textAlign="center">
//       You can resend OTP in {resendTimer} seconds.
//     </Typography>
//   )}
// </Box>
//       </Card>
//       {/* Snackbar for displaying alerts */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };
// export default Verification;




//Before correct keyboard refresh error-----------------------------------------------------------------------------------


// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Container, Card, Box, Typography, TextField, Snackbar, Alert, IconButton } from "@mui/material";
// import { LoadingButton } from "@mui/lab";
// import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";
// import { resendOtp } from "../actions/authActions";
// import { Phone, Security, Timer, Refresh } from "@mui/icons-material";

// const Verification = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const [otp, setOtp] = useState(["", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);
//   const [timer, setTimer] = useState(120);
//   const [isTimerActive, setIsTimerActive] = useState(true);
//   const [isBlocked, setIsBlocked] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" });
//   const [resendLoading, setResendLoading] = useState(false);
//   const [sentOtp, setSentOtp] = useState(location.state?.sentOtp || "");
//   const inputRefs = useRef([]);
//   const { phoneNumber, userData } = location.state || {};
//   const [showResendTimer, setShowResendTimer] = useState(true);
//   const [resendTimer, setResendTimer] = useState(30);

//   useEffect(() => {
//     if (!phoneNumber || !sentOtp) {
//       toast.error("Invalid access. Redirecting to login.");
//       navigate("/login", { replace: true });
//     }
//   }, [phoneNumber, sentOtp, navigate]);

//   useEffect(() => {
//     if (isTimerActive && timer > 0) {
//       const countdown = setInterval(() => {
//         setTimer((prevTimer) => {
//           if (prevTimer <= 1) {
//             clearInterval(countdown);
//             setIsBlocked(true);
//             setSnackbar({
//               open: true,
//               message: "OTP time expired. Please request a new OTP.",
//               severity: "error",
//             });
//             return 0;
//           }
//           return prevTimer - 1;
//         });
//       }, 1000);
//       return () => clearInterval(countdown);
//     }
//   }, [timer, isTimerActive]);

//   const handleOtpChange = (e, index) => {
//     const value = e.target.value;
//     if (/[^0-9]/.test(value)) return;
//     const updatedOtp = [...otp];
//     updatedOtp[index] = value;
//     setOtp(updatedOtp);
//     if (value && index < otp.length - 1) {
//       inputRefs.current[index + 1]?.focus();
//     }
//   };

//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index]) {
//       if (index > 0) {
//         inputRefs.current[index - 1]?.focus();
//       }
//     }
//   };

//   const handleOtpSubmit = () => {
//     const enteredOtp = otp.join("");
//     if (!enteredOtp || enteredOtp !== sentOtp) {
//       setSnackbar({
//         open: true,
//         message: "Invalid OTP. Please try again.",
//         severity: "error",
//       });
//       return;
//     }
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//       setSnackbar({
//         open: true,
//         message: "OTP Verified Successfully!",
//         severity: "success",
//       });
//       localStorage.setItem("phoneNumber", phoneNumber);
//       localStorage.setItem("sentOtp", sentOtp);
//       localStorage.setItem("userData", JSON.stringify(userData));
//       navigate("/home", { state: { phoneNumber, userData: userData?.ResultSet || null } });
//     }, 2000);
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     setShowResendTimer(false);
//     setResendTimer(30);
//     try {
//       const response = await dispatch(resendOtp(phoneNumber));
//       if (response.success) {
//         setTimer(90);
//         setIsBlocked(false);
//         setSnackbar({
//           open: true,
//           message: "OTP has been resent successfully.",
//           severity: "success",
//         });
//         setSentOtp(response.data);
//       } else {
//         setSnackbar({
//           open: true,
//           message: response.error.message || "Failed to resend OTP.",
//           severity: "error",
//         });
//       }
//     } catch (err) {
//       console.error("Error during resend OTP:", err);
//       setSnackbar({
//         open: true,
//         message: "Unexpected error. Please try again.",
//         severity: "error",
//       });
//     } finally {
//       setResendLoading(false);
//       const resendCountdown = setInterval(() => {
//         setResendTimer((prev) => {
//           if (prev <= 1) {
//             clearInterval(resendCountdown);
//             setShowResendTimer(true);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar((prevState) => ({ ...prevState, open: false }));
//   };

//   const formatTime = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}:${secs.toString().padStart(2, '0')}`;
//   };

   
//   useEffect(() => {
     
//     document.body.style.margin = '0';
//     document.body.style.padding = '0';
//     document.body.style.backgroundColor = '#1e3c72';
//     document.documentElement.style.margin = '0';
//     document.documentElement.style.padding = '0';
//     document.documentElement.style.backgroundColor = '#1e3c72';

//     // Cleanup on unmount
//     return () => {
//       document.body.style.margin = '';
//       document.body.style.padding = '';
//       document.body.style.backgroundColor = '';
//       document.documentElement.style.margin = '';
//       document.documentElement.style.padding = '';
//       document.documentElement.style.backgroundColor = '';
//     };
//   }, []);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         width: "100vw",
//         background: "white",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         margin: 0,
//         padding: 0,
//         zIndex: 1,
//       }}
//     >
//       {/* Background decorative elements */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: "-15%",
//           right: "-5%",
//           width: "300px",
//           height: "300px",
//           borderRadius: "50%",
//           background: "linear-gradient(45deg, #FFD700, #FFA500)",
//           opacity: 0.1,
//           zIndex: 0,
//         }}
//       />
// <Box
//   sx={{
//     position: "absolute",
//     bottom: "-15%",
//     left: "-5%",
//     width: "300px",
//     height: "300px",
//     borderRadius: "50%",
//     background: "linear-gradient(45deg,rgb(1, 28, 78),rgb(37, 85, 168))",
//     opacity: 0.1,
//     zIndex: 0,
//   }}
// />

//       <Container
//         maxWidth="sm"
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           width: "100%",
//           maxWidth: { xs: "320px", sm: "400px" },
//           padding: { xs: "8px", sm: "16px" },
//         }}
//       >
//         <Card
//           sx={{
//             borderRadius: { xs: 2, sm: 4 },
//             boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
//             padding: { xs: 2, sm: 4 },
//             background: "rgba(255, 255, 255, 0.95)",
//             backdropFilter: "blur(10px)",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             transition: "all 0.3s ease",
//             width: "100%",


//             "&:hover": {
//               transform: "translateY(-5px)",
//               boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
//             },
//           }}
//         >
//           {/* Header with brand styling */}
//           <Box textAlign="center" mb={{ xs: 2, sm: 4 }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 mb: { xs: 1, sm: 2 },
//                 p: { xs: 1.5, sm: 2 },
//                 borderRadius: "50%",
//                 background: "linear-gradient(45deg, #FFD700, #FFA500)",
//                 width: { xs: 60, sm: 80 },
//                 height: { xs: 60, sm: 80 },
//                 margin: "0 auto",
//                 boxShadow: "0 8px 16px rgba(255, 215, 0, 0.3)",
//               }}
//             >
//               <Security sx={{ fontSize: { xs: 30, sm: 40 }, color: "#1e3c72" }} />
//             </Box>
//             <Typography
//               variant="h4"
//               sx={{
//                 fontWeight: 700,
//                 background: "linear-gradient(45deg, #1e3c72, #2a5298)",
//                 backgroundClip: "text",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 mb: 1,
//                 fontSize: { xs: "1.5rem", sm: "2.125rem" },
//               }}
//             >
//               Verify OTP
//             </Typography>
//             <Typography
//               variant="body1"
//               color="text.secondary"
//               sx={{
//                 fontSize: { xs: 14, sm: 16 },
//                 mb: 1,
//               }}
//             >
//               We've sent a verification code to
//             </Typography>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 mt: 1,
//                 p: { xs: 0.8, sm: 1 },
//                 borderRadius: 2,
//                 background: "linear-gradient(45deg, #FFD700, #FFA500)",
//                 color: "#1e3c72",
//                 fontWeight: 600,
//                 fontSize: { xs: 14, sm: 16 },
//                 mx: { xs: 1, sm: 0 },
//               }}
//             >
//               <Phone sx={{ fontSize: { xs: 16, sm: 18 }, mr: 1 }} />
//               {phoneNumber}
//             </Box>
//           </Box>

//           {/* OTP Input Fields */}
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             mb={{ xs: 2, sm: 3 }}
//             gap={{ xs: 0.5, sm: 1 }}
//             px={{ xs: 1, sm: 0 }}
//           >
//             {otp.map((digit, index) => (
//               <TextField
//                 key={index}
//                 value={digit}
//                 onChange={(e) => handleOtpChange(e, index)}
//                 onKeyDown={(e) => handleKeyDown(e, index)}
//                 inputProps={{
//                   maxLength: 1,
//                   disabled: isBlocked,
//                 }}
//                 sx={{
//                   width: { xs: "45px", sm: "60px" },
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     height: { xs: "45px", sm: "60px" },
//                     fontSize: { xs: "18px", sm: "24px" },
//                     fontWeight: 600,
//                     textAlign: "center",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-2px)",
//                       boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                     },
//                     "&.Mui-focused": {
//                       borderColor: "#FFD700",
//                       boxShadow: "0 0 0 3px rgba(255, 215, 0, 0.2)",
//                     },
//                     "&.Mui-disabled": {
//                       backgroundColor: "#f5f5f5",
//                     },
//                   },
//                   "& input": {
//                     textAlign: "center",
//                     fontSize: { xs: "18px", sm: "24px" },
//                     fontWeight: 600,
//                     color: "#1e3c72",
//                   },
//                 }}
//                 inputRef={(el) => (inputRefs.current[index] = el)}
//               />
//             ))}
//           </Box>

//           {/* Timer Display */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               mb: { xs: 2, sm: 3 },
//               p: { xs: 1.5, sm: 2 },
//               borderRadius: 2,
//               background: isTimerActive
//                 ? "linear-gradient(45deg, #e3f2fd, #f3e5f5)"
//                 : "linear-gradient(45deg, #ffebee, #fce4ec)",
//               border: isTimerActive
//                 ? "2px solid #2196F3"
//                 : "2px solid #f44336",
//               mx: { xs: 1, sm: 0 },
//             }}
//           >
//             <Timer sx={{
//               fontSize: { xs: 18, sm: 20 },
//               mr: 1,
//               color: isTimerActive ? "#2196F3" : "#f44336"
//             }} />
//             {isTimerActive ? (
//               <Typography
//                 variant="body1"
//                 sx={{
//                   fontWeight: 600,
//                   color: "#2196F3",
//                   fontSize: { xs: 14, sm: 16 },
//                 }}
//               >
//                 Time remaining: {formatTime(timer)}
//               </Typography>
//             ) : (
//               <Typography
//                 variant="body1"
//                 sx={{
//                   fontWeight: 600,
//                   color: "#f44336",
//                   fontSize: { xs: 14, sm: 16 },
//                 }}
//               >
//                 OTP expired. Please request a new one.
//               </Typography>
//             )}
//           </Box>

//           {/* Action Buttons */}
//           <Box px={{ xs: 1, sm: 0 }}>
//             <LoadingButton
//               onClick={handleOtpSubmit}
//               loading={loading}
//               variant="contained"
//               sx={{
//                 width: "100%",
//                 height: { xs: 48, sm: 56 },
//                 background: "linear-gradient(45deg, #1e3c72, #2a5298)",
//                 textTransform: "none",
//                 borderRadius: 3,
//                 mb: 2,
//                 fontSize: { xs: 14, sm: 16 },
//                 fontWeight: 600,
//                 boxShadow: "0 8px 16px rgba(30, 60, 114, 0.3)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   background: "linear-gradient(45deg, #2a5298, #1e3c72)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 12px 24px rgba(30, 60, 114, 0.4)",
//                 },
//                 "&:disabled": {
//                   background: "#ccc",
//                   transform: "none",
//                   boxShadow: "none",
//                 },
//               }}
//               disabled={isBlocked || otp.join("").length !== 5}
//             >
//               Verify OTP
//             </LoadingButton>

//             {/* Resend OTP Section */}
//             {isBlocked && showResendTimer && (
//               <LoadingButton
//                 onClick={handleResendOtp}
//                 loading={resendLoading}
//                 variant="outlined"
//                 startIcon={<Refresh />}
//                 sx={{
//                   width: "100%",
//                   height: { xs: 48, sm: 56 },
//                   textTransform: "none",
//                   borderRadius: 3,
//                   fontSize: { xs: 14, sm: 16 },
//                   fontWeight: 600,
//                   borderColor: "#FFD700",
//                   color: "#1e3c72",
//                   borderWidth: 2,
//                   transition: "all 0.3s ease",
//                   "&:hover": {
//                     borderColor: "#FFA500",
//                     backgroundColor: "rgba(255, 215, 0, 0.1)",
//                     transform: "translateY(-2px)",
//                     boxShadow: "0 8px 16px rgba(255, 215, 0, 0.3)",
//                   },
//                 }}
//               >
//                 Resend OTP
//               </LoadingButton>
//             )}

//             {!showResendTimer && (
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   p: { xs: 1.5, sm: 2 },
//                   borderRadius: 2,
//                   background: "linear-gradient(45deg, #fff3e0, #ffe0b2)",
//                   border: "1px solid #FFD700",
//                 }}
//               >
//                 <Timer sx={{ fontSize: { xs: 16, sm: 18 }, mr: 1, color: "#FF8F00" }} />
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontWeight: 600,
//                     color: "#FF8F00",
//                     fontSize: { xs: 12, sm: 14 },
//                   }}
//                 >
//                   You can resend OTP in {resendTimer} seconds
//                 </Typography>
//               </Box>
//             )}
//           </Box>

//           {/* Brand Footer */}
//           <Box textAlign="center" mt={{ xs: 2, sm: 4 }}>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: "#666",
//                 fontWeight: 500,
//                 fontSize: { xs: 12, sm: 14 },
//               }}
//             >
//               Secured by{" "}
//               <span
//                 style={{
//                   background: "linear-gradient(45deg, #FFD700, #FFA500)",
//                   backgroundClip: "text",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   fontWeight: 700,
//                 }}
//               >
//                 Attendme
//               </span>
//             </Typography>
//           </Box>
//         </Card>
//       </Container>

//       {/* Enhanced Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         sx={{
//           "& .MuiSnackbarContent-root": {
//             borderRadius: 3,
//             boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
//           },
//         }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{
//             width: "100%",
//             borderRadius: 3,
//             fontSize: 14,
//             fontWeight: 500,
//           }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default Verification;


import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Card, Box, Typography, Snackbar, Alert } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { resendOtp } from "../actions/authActions";
import { Phone, Security, Timer, Refresh } from "@mui/icons-material";

const Verification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [otp, setOtp] = useState(["", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const [isTimerActive, setIsTimerActive] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" });
  const [resendLoading, setResendLoading] = useState(false);
  const [sentOtp, setSentOtp] = useState(location.state?.sentOtp || "");
  const hiddenInputRef = useRef(null);
  const { phoneNumber, userData } = location.state || {};
  const [showResendTimer, setShowResendTimer] = useState(true);
  const [resendTimer, setResendTimer] = useState(30);

  useEffect(() => {
    if (!phoneNumber || !sentOtp) {
      toast.error("Invalid access. Redirecting to login.");
      navigate("/login", { replace: true });
    }
  }, [phoneNumber, sentOtp, navigate]);

  useEffect(() => {
    if (isTimerActive && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(countdown);
            setIsBlocked(true);
            setSnackbar({
              open: true,
              message: "OTP time expired. Please request a new OTP.",
              severity: "error",
            });
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer, isTimerActive]);

  // Single input handler — one input, one keyboard, never resets
  const handleHiddenInputChange = (e) => {
    if (isBlocked) return;
    const raw = e.target.value.replace(/[^0-9]/g, "").slice(0, 5);
    const newOtp = Array(5).fill("").map((_, i) => raw[i] || "");
    setOtp(newOtp);
  };

  const handleBoxClick = () => {
    if (!isBlocked) {
      hiddenInputRef.current?.focus();
    }
  };

  const handleOtpSubmit = () => {
    const enteredOtp = otp.join("");
    if (!enteredOtp || enteredOtp !== sentOtp) {
      setSnackbar({
        open: true,
        message: "Invalid OTP. Please try again.",
        severity: "error",
      });
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSnackbar({
        open: true,
        message: "OTP Verified Successfully!",
        severity: "success",
      });
      localStorage.setItem("phoneNumber", phoneNumber);
      localStorage.setItem("sentOtp", sentOtp);
      localStorage.setItem("userData", JSON.stringify(userData));
      navigate("/home", { state: { phoneNumber, userData: userData?.ResultSet || null } });
    }, 2000);
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    setShowResendTimer(false);
    setResendTimer(30);
    try {
      const response = await dispatch(resendOtp(phoneNumber));
      if (response.success) {
        setTimer(90);
        setIsBlocked(false);
        setSnackbar({
          open: true,
          message: "OTP has been resent successfully.",
          severity: "success",
        });
        setSentOtp(response.data);
      } else {
        setSnackbar({
          open: true,
          message: response.error.message || "Failed to resend OTP.",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Error during resend OTP:", err);
      setSnackbar({
        open: true,
        message: "Unexpected error. Please try again.",
        severity: "error",
      });
    } finally {
      setResendLoading(false);
      const resendCountdown = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(resendCountdown);
            setShowResendTimer(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prevState) => ({ ...prevState, open: false }));
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.backgroundColor = "#1e3c72";
    document.documentElement.style.margin = "0";
    document.documentElement.style.padding = "0";
    document.documentElement.style.backgroundColor = "#1e3c72";
    return () => {
      document.body.style.margin = "";
      document.body.style.padding = "";
      document.body.style.backgroundColor = "";
      document.documentElement.style.margin = "";
      document.documentElement.style.padding = "";
      document.documentElement.style.backgroundColor = "";
    };
  }, []);

  const filledCount = otp.filter((d) => d !== "").length;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        background: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: 0,
        padding: 0,
        zIndex: 1,
      }}
    >
      {/* Background decorative elements */}
      <Box
        sx={{
          position: "absolute",
          top: "-15%",
          right: "-5%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "linear-gradient(45deg, #FFD700, #FFA500)",
          opacity: 0.1,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-15%",
          left: "-5%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "linear-gradient(45deg,rgb(1, 28, 78),rgb(37, 85, 168))",
          opacity: 0.1,
          zIndex: 0,
        }}
      />

      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          maxWidth: { xs: "320px", sm: "400px" },
          padding: { xs: "8px", sm: "16px" },
        }}
      >
        <Card
          sx={{
            borderRadius: { xs: 2, sm: 4 },
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            padding: { xs: 2, sm: 4 },
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            transition: "all 0.3s ease",
            width: "100%",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
            },
          }}
        >
          {/* Header with brand styling */}
          <Box textAlign="center" mb={{ xs: 2, sm: 4 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: { xs: 1, sm: 2 },
                p: { xs: 1.5, sm: 2 },
                borderRadius: "50%",
                background: "linear-gradient(45deg, #FFD700, #FFA500)",
                width: { xs: 60, sm: 80 },
                height: { xs: 60, sm: 80 },
                margin: "0 auto",
                boxShadow: "0 8px 16px rgba(255, 215, 0, 0.3)",
              }}
            >
              <Security sx={{ fontSize: { xs: 30, sm: 40 }, color: "#1e3c72" }} />
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                background: "linear-gradient(45deg, #1e3c72, #2a5298)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                mb: 1,
                fontSize: { xs: "1.5rem", sm: "2.125rem" },
              }}
            >
              Verify OTP
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontSize: { xs: 14, sm: 16 }, mb: 1 }}
            >
              We've sent a verification code to
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
                p: { xs: 0.8, sm: 1 },
                borderRadius: 2,
                background: "linear-gradient(45deg, #FFD700, #FFA500)",
                color: "#1e3c72",
                fontWeight: 600,
                fontSize: { xs: 14, sm: 16 },
                mx: { xs: 1, sm: 0 },
              }}
            >
              <Phone sx={{ fontSize: { xs: 16, sm: 18 }, mr: 1 }} />
              {phoneNumber}
            </Box>
          </Box>

          {/* OTP Visual Boxes + Single Hidden Input */}
          <Box
            onClick={handleBoxClick}
            sx={{
              position: "relative",
              cursor: "text",
              mb: { xs: 2, sm: 3 },
              px: { xs: 1, sm: 0 },
            }}
          >
            {/* Single hidden input — numeric pad only, never switches keyboard */}
            <input
              ref={hiddenInputRef}
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="one-time-code"
              value={otp.join("")}
              onChange={handleHiddenInputChange}
              disabled={isBlocked}
              style={{
                position: "absolute",
                opacity: 0,
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                fontSize: "16px", // prevents iOS auto-zoom
                border: "none",
                outline: "none",
                zIndex: 1,
                cursor: "text",
                caretColor: "transparent",
              }}
            />

            {/* Visual digit boxes */}
            <Box display="flex" justifyContent="space-between" gap={{ xs: 0.5, sm: 1 }}>
              {otp.map((digit, index) => (
                <Box
                  key={index}
                  sx={{
                    width: { xs: "45px", sm: "60px" },
                    height: { xs: "45px", sm: "60px" },
                    borderRadius: 2,
                    border:
                      index === filledCount
                        ? "2px solid #FFD700"
                        : digit
                        ? "2px solid #2a5298"
                        : "2px solid #e0e0e0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: { xs: "18px", sm: "24px" },
                    fontWeight: 600,
                    color: "#1e3c72",
                    backgroundColor: isBlocked
                      ? "#f5f5f5"
                      : digit
                      ? "rgba(30,60,114,0.05)"
                      : "white",
                    boxShadow:
                      index === filledCount
                        ? "0 0 0 3px rgba(255,215,0,0.2)"
                        : digit
                        ? "0 4px 8px rgba(0,0,0,0.08)"
                        : "none",
                    transition: "all 0.2s ease",
                    userSelect: "none",
                  }}
                >
                  {digit || ""}
                </Box>
              ))}
            </Box>
          </Box>

          {/* Timer Display */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: { xs: 2, sm: 3 },
              p: { xs: 1.5, sm: 2 },
              borderRadius: 2,
              background: isTimerActive
                ? "linear-gradient(45deg, #e3f2fd, #f3e5f5)"
                : "linear-gradient(45deg, #ffebee, #fce4ec)",
              border: isTimerActive ? "2px solid #2196F3" : "2px solid #f44336",
              mx: { xs: 1, sm: 0 },
            }}
          >
            <Timer
              sx={{
                fontSize: { xs: 18, sm: 20 },
                mr: 1,
                color: isTimerActive ? "#2196F3" : "#f44336",
              }}
            />
            {isTimerActive ? (
              <Typography
                variant="body1"
                sx={{ fontWeight: 600, color: "#2196F3", fontSize: { xs: 14, sm: 16 } }}
              >
                Time remaining: {formatTime(timer)}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                sx={{ fontWeight: 600, color: "#f44336", fontSize: { xs: 14, sm: 16 } }}
              >
                OTP expired. Please request a new one.
              </Typography>
            )}
          </Box>

          {/* Action Buttons */}
          <Box px={{ xs: 1, sm: 0 }}>
            <LoadingButton
              onClick={handleOtpSubmit}
              loading={loading}
              variant="contained"
              sx={{
                width: "100%",
                height: { xs: 48, sm: 56 },
                background: "linear-gradient(45deg, #1e3c72, #2a5298)",
                textTransform: "none",
                borderRadius: 3,
                mb: 2,
                fontSize: { xs: 14, sm: 16 },
                fontWeight: 600,
                boxShadow: "0 8px 16px rgba(30, 60, 114, 0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  background: "linear-gradient(45deg, #2a5298, #1e3c72)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 12px 24px rgba(30, 60, 114, 0.4)",
                },
                "&:disabled": {
                  background: "#ccc",
                  transform: "none",
                  boxShadow: "none",
                },
              }}
              disabled={isBlocked || otp.join("").length !== 5}
            >
              Verify OTP
            </LoadingButton>

            {/* Resend OTP Section */}
            {isBlocked && showResendTimer && (
              <LoadingButton
                onClick={handleResendOtp}
                loading={resendLoading}
                variant="outlined"
                startIcon={<Refresh />}
                sx={{
                  width: "100%",
                  height: { xs: 48, sm: 56 },
                  textTransform: "none",
                  borderRadius: 3,
                  fontSize: { xs: 14, sm: 16 },
                  fontWeight: 600,
                  borderColor: "#FFD700",
                  color: "#1e3c72",
                  borderWidth: 2,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    borderColor: "#FFA500",
                    backgroundColor: "rgba(255, 215, 0, 0.1)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 16px rgba(255, 215, 0, 0.3)",
                  },
                }}
              >
                Resend OTP
              </LoadingButton>
            )}

            {!showResendTimer && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: { xs: 1.5, sm: 2 },
                  borderRadius: 2,
                  background: "linear-gradient(45deg, #fff3e0, #ffe0b2)",
                  border: "1px solid #FFD700",
                }}
              >
                <Timer sx={{ fontSize: { xs: 16, sm: 18 }, mr: 1, color: "#FF8F00" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#FF8F00", fontSize: { xs: 12, sm: 14 } }}
                >
                  You can resend OTP in {resendTimer} seconds
                </Typography>
              </Box>
            )}
          </Box>

          {/* Brand Footer */}
          <Box textAlign="center" mt={{ xs: 2, sm: 4 }}>
            <Typography
              variant="body2"
              sx={{ color: "#666", fontWeight: 500, fontSize: { xs: 12, sm: 14 } }}
            >
              Secured by{" "}
              <span
                style={{
                  background: "linear-gradient(45deg, #FFD700, #FFA500)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 700,
                }}
              >
                Attendme
              </span>
            </Typography>
          </Box>
        </Card>
      </Container>

      {/* Enhanced Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            borderRadius: 3,
            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
          },
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%", borderRadius: 3, fontSize: 14, fontWeight: 500 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Verification;